import { render } from "./WikiHomeView.vue?vue&type=template&id=4f795192&scoped=true"
import script from "./WikiHomeView.vue?vue&type=script&lang=js"
export * from "./WikiHomeView.vue?vue&type=script&lang=js"

import "./WikiHomeView.vue?vue&type=style&index=0&id=4f795192&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f795192"]])

export default __exports__